import { rfaDepositService } from 'aem-libs-api/src/services/rfa-depositcalc/v1'
import { getConfig } from 'aem-libs-react-ts/src/utils/getConfig'

export const rfaDepositApi = rfaDepositService(getConfig())
